import React from 'react';
import { ResponsiveGrid } from '@fpxfd/next';
import BillboardCom from './components/BillboardCom';

const { Cell } = ResponsiveGrid;

const Billboard = () => {
  return (
    <ResponsiveGrid>
      <Cell colSpan={12}>
        <BillboardCom />
      </Cell>
    </ResponsiveGrid>
  );
};

export default Billboard;
